import { create } from "zustand";

interface ConversationStore {
  transcriptSelectedText?: string;
  setTranscriptSelectedText: (text: string) => void;
  transcriptScrollToMessageId?: string;
  transcriptScrollRequestId: number;
  requestTranscriptScroll: (text: string, messageId?: string) => void;
  clearTranscriptHighlight: () => void;
}

export const useConversationStore = create<ConversationStore>((set) => ({
  transcriptSelectedText: "",
  setTranscriptSelectedText: (text: string) =>
    set({ transcriptSelectedText: text }),
  transcriptScrollToMessageId: undefined,
  // Bumped on every request so repeating the same one still scrolls, even
  // though the text and message id are unchanged.
  transcriptScrollRequestId: 0,
  requestTranscriptScroll: (text: string, messageId?: string) =>
    set((state) => ({
      transcriptSelectedText: text,
      transcriptScrollToMessageId: messageId,
      transcriptScrollRequestId: state.transcriptScrollRequestId + 1,
    })),
  clearTranscriptHighlight: () =>
    set({ transcriptSelectedText: "", transcriptScrollToMessageId: undefined }),
}));
